import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/paths';

export const HomeCta = () => (
  <Box
    sx={{
      py: { xs: 10, md: 16 },
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    {/* Gradient background */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.info.main} 100%)`,
      }}
    />

    <Container
      maxWidth="md"
      sx={{ position: 'relative', zIndex: 1 }}
    >
      <Stack
        alignItems="center"
        spacing={4}
        sx={{ textAlign: 'center' }}
      >
        <Typography
          variant="h2"
          sx={{
            color: 'common.white',
            fontWeight: 800,
            fontSize: { xs: 28, md: 40 },
          }}
        >
          데이터로 투자 지역을 선정하세요
        </Typography>
        <Typography
          sx={{
            color: (theme) => alpha(theme.palette.common.white, 0.8),
            fontSize: { xs: 16, md: 18 },
            maxWidth: 500,
          }}
        >
          감이 아닌 데이터로. 매주 업데이트되는 시장 분석을 확인하세요.
        </Typography>
        <Button
          component={RouterLink}
          href={paths.dashboard.index}
          size="large"
          variant="contained"
          sx={{
            backgroundColor: 'common.white',
            color: 'primary.main',
            px: 5,
            py: 1.5,
            fontSize: 16,
            fontWeight: 700,
            borderRadius: 2,
            '&:hover': {
              backgroundColor: (theme) => alpha(theme.palette.common.white, 0.9),
            },
          }}
        >
          시작하기
        </Button>
      </Stack>
    </Container>
  </Box>
);
